import React from 'react';
import './AnimalExclusionFilters.css';

const OPTIONS = [
  { key: 'excludeBats', label: 'Exclude bats' },
  { key: 'excludeRatsMice', label: 'Exclude rats / mice' },
  { key: 'excludeShrews', label: 'Exclude shrews' }
];

function AnimalExclusionFilters({ exclusions, onChange }) {
  return (
    <fieldset className="animal-exclusions">
      <legend>Exclude groups</legend>
      <div className="animal-exclusions__options">
        {OPTIONS.map(({ key, label }) => (
          <label key={key} className="animal-exclusions__option">
            <input
              type="checkbox"
              checked={exclusions[key]}
              onChange={event => onChange(key, event.target.checked)}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}

export default AnimalExclusionFilters;
